import * as React from 'react';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';
import { WeblabedFeatures } from '../constants';
import { logMetadata as logMetadataWithTakt } from '../utils/logWithTakt';
import { logMetadata as logMetadataWithCSM } from '../utils/logWithCSM';

const WEBLAB_MAPPING = new Map([
  [WeblabedFeatures.AAC_NAV_TEST, 'AAC_NAV_TEST_861688'],
]);

export default (): void => {
  const { config: internalChromeConfig } = useInternalChromeConfigContext();
  React.useEffect(() => {
    const featureLaunchInfoMap = new Map(
      internalChromeConfig.featureLaunchInfo?.features.map((feature) => [
        feature.name,
        feature.isEnabled,
      ]),
    );
    const weblabs = Array.from(WEBLAB_MAPPING.entries()).reduce(
      (acc, [featureName, weblab]) => {
        acc[weblab] =
          featureLaunchInfoMap.get(featureName) === true ? 'T1' : 'C';
        return acc;
      },
      {},
    );

    logMetadataWithTakt({ weblabs });
    logMetadataWithCSM({ weblabs });
  }, []);
};
